import React from "react";
import { AdStatus } from "../../../models";
import styles from "./adStatusLabel.scss";

const AdStatusLabel = ({ status }) => {
  const getStatusString = (value: number) => {
    switch (value) {
      case AdStatus.active:
        return "Aktivan";
      case AdStatus.paused:
        return "Pauziran";
      case AdStatus.sold:
        return "Prodano";
      case AdStatus.expired:
        return "Istekao";
      default:
        return "";
    }
  };

  const getStatusStyle = (value: number) => {
    switch (value) {
      case AdStatus.active:
        return styles.activeLabel;
      case AdStatus.paused:
        return styles.pausedLabel;
      case AdStatus.sold:
        return styles.soldLabel;
      case AdStatus.expired:
        return styles.expiredLabel;
      default:
        return null;
    }
  };

  return (
    <span className={`${styles.statusLabel} ${getStatusStyle(status)}`}>
      {getStatusString(status)}
    </span>
  );
};

export default AdStatusLabel;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdStatusLabel/AdStatusLabel.tsx